module.exports = __webpack_public_path__ + "img/EMS_user_manual7.ec12b8bf.png";